import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// get Dashboard Main
function getDashboardMain(params: any) {
    const baseUrl = '/dashboard/getMainInfo';
    return api.create(`${baseUrl}`, params);
}

// get Report Ready
function getReportReady(params: any) {
    const baseUrl = '/dashboard/getMReportReadyList';
    return api.create(`${baseUrl}`, params);
}

// get Patient List
function getPatientList(params: any) {
    const baseUrl = '/dashboard/getPatientList';
    return api.create(`${baseUrl}`, params);
}

function getCategorySales(params: any) {
    const baseUrl = '/dashboard/getCatgSales';
    return api.create(`${baseUrl}`, params);
}

function getCategoryYearlySales(params: any) {
    const baseUrl = '/dashboard/getCatgSales';
    return api.create(`${baseUrl}`, params);
}

export { getReportReady, getDashboardMain, getPatientList, getCategorySales };
